import { AbilityBuilder, Ability } from '@casl/ability'

import Booking from '@/models/booking'

export default function getAbilitiesFor(booking: Booking): Ability {
  const { paymentAllowed } = booking

  return AbilityBuilder.define({ subjectName: () => 'Booking' }, (can: any) => {
    if (paymentAllowed) {
      can('pay', 'Booking')
    }
  })
}
